import React, { useState } from "react";

import RenderMain from "./RenderMain";
import ProcessingBar from "utils/Processingbar";
import RenderSidebar from "./RenderSidebar";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const CheckOutProcess = () => {
  const user = useSelector((state) => state.auth.user);

  // console.log({ user });
  const [formData, setFormData] = useState({
    selectedDateTime: null,
    orderingMethod: "",
    paymentMethod: "",

    name: user?.displayName || "",
    email: user?.username || "",
    mobile: user?.phone || "",
    message: "",
  });

  const [currentStep, setCurrentStep] = useState(0);
  const [stepProcessing, setStepProcessing] = useState({
    dateTime: false,
    ordering: false,
    contact: false,
  });

  const isLastStep = currentStep === 3;
  const isFirstStep = currentStep === 0;

  const handleNext = async () => {
    const stepKey = ["dateTime", "ordering", "payment", "contact", "done"][
      currentStep
    ];

    setStepProcessing((prev) => ({ ...prev, [stepKey]: true }));

    await new Promise((res) => setTimeout(res, 0));

    setStepProcessing((prev) => ({ ...prev, [stepKey]: false }));
    if (!isLastStep) setCurrentStep((prev) => prev + 1);
  };

  const isStepValid = () => {
    if (currentStep === 0) return !!formData.selectedDateTime;
    if (currentStep === 1) return !!formData.orderingMethod;
    if (currentStep === 2) return !!formData.paymentMethod;
    if (currentStep === 3)
      return !!formData.name && !!formData.email && !!formData.mobile;
    return true;
  };

  const handleBack = () => {
    if (!isFirstStep) setCurrentStep((prev) => prev - 1);
  };

  return (
    <div className="nc-CheckOutPagePageMain">
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col lg:flex-row gap-10">
        {/* Main Content */}
        <div className="w-full lg:w-3/5 xl:w-2/3">
          <RenderMain
            formData={formData}
            setFormData={setFormData}
            currentStep={currentStep}
            handleNext={handleNext} // ✅ Add this
          />
        </div>

        {/* Sticky Sidebar */}
        <div className="w-full lg:w-2/5 xl:w-1/3">
          <div className="sticky top-24">
            <RenderSidebar
              formData={formData}
              handleNext={handleNext} // ✅ must be passed
              handleBack={handleBack}
              currentStep={currentStep}
              isFirstStep={isFirstStep}
              isLastStep={isLastStep}
              stepProcessing={stepProcessing}
              isStepValid={isStepValid()} // <- pass
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckOutProcess;
